import { stringify } from "query-string";
import { dateRangeType } from "../dynamic/articleList/src/types";

interface params {
  page: number;
  categoryId: string | number | undefined;
  typeId: string | undefined;
  startDate?: string;
  endDate?: string;
  playerId?: string;
  tournamentId?: string;
  tag?: string;
  searchTerm?: string;
  language?: string;
}

const newsEndPoint = "/tennis/api/ArticleListApi/GetArticles?";
const photosEndPoint = "/tennis/api/ImagesApi/GetImages?";

export async function getArticles(params: Record<string, any>) {
  const response = await fetch(
    `${process.env.HOST}${newsEndPoint}${stringify(params)}`
  );
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}

export async function getNews(
  page: number,
  newsType: "articles" | "photos" = "articles",
  categoryId?: string | number,
  typeId?: string,
  dateRange?: dateRangeType,
  playerId?: string,
  tournamentId?: string,
  tag?: string,
  searchTerm?: string,
  LanguageCode?: string
) {
  let params: params = {
    page,
    language: LanguageCode,
    categoryId,
    typeId,
    playerId,
    tournamentId,
    tag,
    searchTerm
  };
  let endpoint;
  if (newsType === "articles") {
    endpoint = newsEndPoint;
  } else {
    endpoint = photosEndPoint;
  }

  if (dateRange && dateRange.startDate) {
    params.startDate = dateRange.startDate.format("YYYY-MM-DD");
  }
  if (dateRange && dateRange.endDate) {
    params.endDate = dateRange.endDate.format("YYYY-MM-DD");
  }
  const response = await fetch(
    `${process.env.HOST}${endpoint}${stringify(params)}`
  );
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}
